/**
 * @file        encodings.js
 *              Utilities for working with various content transfer
 *              encodings, like base64.
 * @author      Wes Garland, wes@kingsds.network
 * @date        Feb 2022
 */

 exports.atob = globalThis.atob || require('atob');
 exports.btoa = globalThis.btoa || require('btoa');